import React from 'react';
import { node, oneOf, string } from 'prop-types';
import { styCol } from './style';

const Col = (props) => {
  const { children, className, maxSize, minSize, size, ...rest } = props;

  return (
    <div className={`${styCol({ size, maxSize, minSize })} ${className}`} {...rest}>
      {children}
    </div>
  );
};

Col.propTypes = {
  children: node,
  className: string,
  maxSize: oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 'auto']),
  minSize: oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 'auto']),
  size: oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 'auto']),
};

Col.defaultProps = {
  children: null,
  className: '',
  maxSize: null,
  minSize: null,
  size: null,
};

export default Col;
